import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import Store from './store';

const styles = require('./index.less');

/**
 * 弹窗模板, 可以快速套用修改
 */
const AppointmentSuccessModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.appointmentSuccessModalRoot)}>
        <div className="appointment-success-modal-root">
          <div className="appointment-success-modal-group-1" data-name="预约成功2">
            <div className="appointment-success-modal-layer-1" />
            <div className="appointment-success-modal-layer-2" />
            <div className="appointment-success-modal-layer-3" />
            <div className="appointment-success-modal-layer-4" />
            <div className="appointment-success-modal-layer-5" onClick={() => store.appointmentByMiniprogram()} />
            <Link
              className="appointment-success-modal-layer-6"
              onClick={() => {
                store.onClickClose();
                onClose();
              }}
            />
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(AppointmentSuccessModal, Store);
